import "./Footer.css";
import { Link } from "react-router-dom";
import {
  FaInstagram,
  FaFacebookF,
  FaLinkedinIn,
} from "react-icons/fa";
import { motion } from "framer-motion";
import { useBrand } from "../brand/BrandContext";

function Footer() {
  const brand = useBrand();
  return (
    <footer className="footer">
      <div className="footer-content">
        {/* Copyright */}
        <p className="footer-text">
          © {brand.foundedYear || new Date().getFullYear()} {brand.name}.
          <br />
          All rights reserved.
        </p>

        {/* Policy links */}
        <nav className="footer-policy-links" aria-label="Policies">
          <Link to="/policies/#terms"    data-testid="footer-terms">Terms &amp; Conditions</Link>
          <span aria-hidden="true">·</span>
          <Link to="/policies/#privacy"  data-testid="footer-privacy">Privacy Policy</Link>
          <span aria-hidden="true">·</span>
          <Link to="/policies/#refund"   data-testid="footer-refund">Refund &amp; Cancellation</Link>
          <span aria-hidden="true">·</span>
          <Link to="/policies/#shipping" data-testid="footer-shipping">Shipping &amp; Delivery</Link>
        </nav>

        {/* Social Icons */}
        <div className="social-icons">
          {/* Instagram */}
          {brand.social.instagram && <motion.a
            href={brand.social.instagram}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
            className="social-link"
            whileHover={{ scale: 1.25, y: -6 }}
            whileTap={{ scale: 0.9 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            <FaInstagram />
          </motion.a>}

          {/* Facebook */}
          {brand.social.facebook && <motion.a
            href={brand.social.facebook}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
            className="social-link"
            whileHover={{ scale: 1.25, y: -6 }}
            whileTap={{ scale: 0.9 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            <FaFacebookF />
          </motion.a>}

          {/* LinkedIn */}
          {brand.social.linkedin && <motion.a
            href={brand.social.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
            className="social-link"
            whileHover={{ scale: 1.25, y: -6 }}
            whileTap={{ scale: 0.9 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            <FaLinkedinIn />
          </motion.a>}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
